import { useQuery } from 'react-query';
import { CACHE_1_HOUR_MS } from '../../../config/utils/cacheUtils';
import { ProductFormData } from '../../../interfaces/product.interface';
import { apiRQ } from '../../api';

const getProductForm = async (): Promise<ProductFormData> => {
  const resp = await apiRQ.get<ProductFormData>('/form-data/product');

  return resp.data;
};

export const useProductForm = () => {
  return useQuery<ProductFormData, Error>(['getProductForm'], () => getProductForm(), {
    cacheTime: CACHE_1_HOUR_MS,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
